import { IDefaultFilterItem } from "../types/interfaces";

// Kiosk-切版模式-標準預覽圖片(橫)
export const LAYOUT_STANDARD_PREVIEW = "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/amaze-normal-landscape.png";
// Kiosk-切版模式-標準預覽圖片(直)
export const LAYOUT_STANDARD_PREVIEW_PORTRAIT =
    "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/Standard Gesture Tips Language List.png";

// Kiosk-切版模式-導覽預覽圖片
export const LAYOUT_GUIDE_PREVIEW =
    "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/Interface Guide without Gestures.png";

// Kiosk-切版模式-主播預覽圖片 （廣告在右）
export const LAYOUT_BROADCAST_PREVIEW_WITH_RIGHT_AD =
    "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/Interface Design.png";
// Kiosk-切版模式-主播預覽圖片 （廣告在左）
export const LAYOUT_BROADCAST_PREVIEW_WITH_LEFT_AD =
    "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/Interface Design Ad Gestures Language Dropdown.png";

// Kiosk-切版模式-分區預覽圖片（廣告在上）
export const LAYOUT_SECTION_PREVIEW_WITH_TOP_AD =
    "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/Ad Layout with Gestures.png";
// Kiosk-切版模式-分區預覽圖片（廣告在下）
export const LAYOUT_SECTION_PREVIEW_WITH_BOTTOM_AD =
    "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/Ad Layout Gestures.png";

// Kiosk-天氣簡易模式
export const WEATHER_SIMPLE_PREVIEW = "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/天氣與時間介面_僅時間.jpg";
// Kiosk-天氣詳細模式
export const WEATHER_DETAILED_PREVIEW =
    "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/天氣與時間介面_完整顯示.jpg";

// Kiosk-提示詞-喇叭圖示
export const HINTS_SPEARKER_ICON = "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/提示詞_喇叭圖示.png";
// Kiosk-提示詞-手指圖示
export const HINTS_FINDER_ICON = "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/提示詞_手指圖示.png";

/**
 * kiosk-預設濾鏡設定
 * 預設濾鏡永遠啟用，無法被使用者停用
 */
export const DEFAULT_PHOTO_FILTERS: IDefaultFilterItem[] = [
    {
        key: "default-filter-1",
        name: "預設濾鏡 1",
        url: "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/amaze-default-filters-1.png",
    },
    {
        key: "default-filter-2",
        name: "預設濾鏡 2",
        url: "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/amaze-default-filters-2.png",
    },
];

/**
 * kiosk-預設背景圖片 URL
 * 當使用者未上傳自訂背景時顯示的白色背景圖
 */
export const DEFAULT_BACKGROUND_URL =
    "https://cdn-tbd-warehouse.thebarkingdog.tw/frontend/amaze-default-background.png";
